import { useCallback } from 'react';
import { useLocation } from 'react-router';

import { focusFlowV2Paths } from '@perpay-web/fintech/props/appPaths';
import {
    componentStackProviderFactory,
    useComponentStack,
    useComponentStackRender,
} from '@perpay-web/hooks/useComponentStack';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const [TransparentHeaderProvider, useTransparentHeaderContext] =
    createContextProvider(componentStackProviderFactory);

export { TransparentHeaderProvider };

export const useTransparentHeader = () => {
    const context = useTransparentHeaderContext();

    const renderCb = useCallback(() => true, []);

    useComponentStack(context, renderCb);
};

export const useTransparentHeaderRender = (): boolean => {
    const location = useLocation();
    const override = useComponentStackRender(useTransparentHeaderContext());

    if (override) {
        return true;
    }

    // This is a deprecated solution. Do not use the path for detecting the transparent header.
    return focusFlowV2Paths.some((focusFlowPath) =>
        location.pathname.startsWith(focusFlowPath),
    );
};
